export const isValidAirTravelerName = (name: string | undefined): boolean =>
  (name?.replace(/\s/g, "").length ?? 0) >= 2;
